import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

enum API_ENDPOINTS {
  GET_DEPARTMENTS = 'Machine/GetDepartmentByPlant',
  GET_MODULE = 'OverallActionPlan/getModule',
  GET_ACTION_PLAN =  'OverallActionPlan/GetActionPlan',
  ADD_ACTION_USER_ACTION = 'OverallActionPlan/AddActionUserAction',
  ADD_ACTION_PLAN = 'OverallActionPlan/AddActionPlan',
  ADD_ACTION_COMPLETED = 'OverallActionPlan/AddActionCompleted',
  ADD_NEW_TARGET_DATE = 'OverallActionPlan/AddNewTargetDate',
  ADD_REVISED_DATE = 'OverallActionPlan/AddRevisedDate',
  UPDATE_ACTION_PLAN = 'OverallActionPlan/UpdateActionPlan',
  SEND_MAIL = 'EdgeData/SendEmail',
  GET_M_CLASSIFICATION = 'OverallActionPlan/GetMClassification'
}

@Injectable({
  providedIn: 'root',
})
export class OverallActionPlanService {

  // mClassificationTypes: any[] = [
  //   { Name: 'Man', Id: 1 },
  //   { Name: 'Material', Id: 2 },
  //   { Name: 'Method', Id: 3 },
  //   { Name: 'Machine', Id: 4 }
  // ]
  
get apiUrl(): string { return Constants.CORE_API_BASE_URL; }  constructor(private http: HttpClient) { }

  GetActionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.GET_ACTION_PLAN, data );
  }

  getNewModule() {
    return this.http.get<any[]>(this.apiUrl + API_ENDPOINTS.GET_MODULE)
  }

  addActionCompleted(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.ADD_ACTION_COMPLETED, data );
  }

  addNewTargetDate(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.ADD_NEW_TARGET_DATE, data );
  }

  addRevisedDate(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.ADD_REVISED_DATE, data );
  }

  AddApprovedAction(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.ADD_REVISED_DATE, data ); //Not being use anywhere, although this is called addApprovedAction, it was using Revised Date Endpoint
  }

  editActionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.UPDATE_ACTION_PLAN, data);
  }

  sendMail(data: any): Observable<any[]> {
    return this.http.post<any>(this.apiUrl + API_ENDPOINTS.SEND_MAIL, data);
  }

  addActionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.ADD_ACTION_PLAN, data);
  }
  
  AddActionUserAction(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.ADD_ACTION_USER_ACTION, data)
  }

  getDeptData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.apiUrl + API_ENDPOINTS.GET_DEPARTMENTS, data);
  }

  getMClassification(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + API_ENDPOINTS.GET_M_CLASSIFICATION)
  }
}
